import axiosInstance from "../helpers/axiosInstance";

// Records the first scan on the packing screen for an audited order.
// Idempotent on the server, so retrying after an error is safe.
export const startPackingAudit = async (orderId) => {
    const res = await axiosInstance.post(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/orders/${orderId}/packing-audit/start`
    )
    return res.data
}

// Submits the three audit answers and finalizes the audit.
// answers: { missing_items, missing_items_quantity?, extra_items, extra_items_quantity?, debris_present, scans_count }
export const answerPackingAudit = async (orderId, answers) => {
    const res = await axiosInstance.post(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/orders/${orderId}/packing-audit/answer`,
        answers
    )
    return res.data
}
